import { render } from "./StatistichePDC.vue?vue&type=template&id=1a766fa3"
import script from "./StatistichePDC.vue?vue&type=script&lang=js"
export * from "./StatistichePDC.vue?vue&type=script&lang=js"

import exportComponent from "/Users/gigi/Library/ask_admin-deps/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__